// eslint-disable-next-line
export function selectOnlineStatus(slice) {
  if (typeof slice.online === 'undefined') {
    return true;
  }
  return slice.online;
}
